import forge from 'node-forge';
import { getTranslation } from 'src/utilities/translator';
import yup from 'src/utilities/Yup/yup';

export const LAST_UPDATED_LS_KEY = 'apiContentEncryptionLastUpdated';

export const HTTPS_URL_REGEX =
  /https:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&//=]*)/;

export enum APIContentEncryptionFieldName {
  Key = 'key',
  IsActive = 'active',
}

export const APIContentEncryptionFormSchema = yup.object().shape({
  [APIContentEncryptionFieldName.IsActive]: yup.boolean().default(false),
  [APIContentEncryptionFieldName.Key]: yup
    .string()
    .default('')
    .when(APIContentEncryptionFieldName.IsActive, {
      is: true,
      then: schema =>
        schema
          .required(
            getTranslation(
              'devOption_callbackencryption_publicKey_error_Required',
            ),
          )
          .matches(
            /^(-----BEGIN PUBLIC KEY-----)([\s\S]*)(-----END PUBLIC KEY-----)$/,
            getTranslation(
              'devOption_callbackencryption_publicKey_error_invalidKeyFormat',
            ),
          )
          .test({
            name: 'is-valid-rsa-key-and-size',
            test: function (value) {
              if (!value) return true; // Let the required check handle empty values

              try {
                const publicKey = forge.pki.publicKeyFromPem(value);

                // Check if the key size is sufficient
                if (publicKey.n.bitLength() < 8192) {
                  return this.createError({
                    message: getTranslation(
                      'devOption_callbackencryption_publicKey_error_minimumSize',
                    ),
                  });
                }

                return true;
              } catch (error) {
                return this.createError({
                  message: getTranslation(
                    'devOption_callbackencryption_publicKey_error_invalidKeyFormat',
                  ),
                });
              }
            },
          }),
    }),
});

export const LABELS = {
  apiContentEncryption: {
    textArea: {
      label: 'Public Key',
      placeholder:
        '-----BEGIN PUBLIC KEY-----MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAo11IZdXneVVWZEBlVQu1PYZMc5j+lVlVCjGA46+E3DzS621+ILjfA+si4eFZkPcLisIVxbIZ8J6hTQHJ3KVFscGurlAdEoxKR0Hmlv6BA+3DeQNlBO5FcYXNqAtihH78NJzmDvU7LYxNfNWV3JbL2BQjAv/eZVF5IkM3BNR/FYKiQUVpOM9isRKU40P00W+Cj/iDLxRMCctxydcR4vr5BoSNeg/QB5HETlQmR2gRa4TMxojOzn9r83XCqMt3yWlVf6wHIZi1wl304bZ6bafrioqKWQvNtSf7OCBk2FXTBwvxnC1GOFxJ4NVNVT6qEpKEoTkBazXexskJ6Py3lw4znoAzrRNkofCpZPzovpz7zNE4+UjeWFzLz3lxmOD2UJpPQ/9ezqkKb8YJKPcMVmGzrUPec4xGg/uc+iaxN0LpYCWBHfR5Y6y7iA6AhICIYc/oxd2wDMkNRIz7K90nsYY15KfESxgixh7OyYMykb5GQb1rxWnd0B172ceFWPJ9elWjsapdpNVx5Zw+SCrgfLyYpgRw5qw2oHBe0ZsosG+YNcDc9q6JmXZA97mcpwf8KL3TxT5egPpStppgRt/pRrwYB9yyI7q/n8GF0LulZg5aaIvkS0KiGgw3mvQ0Vt8AXomj5YZJgTVWh9qf79aelieLxkk7/h7MgGR5AcL8UorjOOsCAwEAAQ==\n-----END PUBLIC KEY-----',
    },
  },
};

export const TOGGLE_OPTIONS = [
  { label: 'common_yes', value: 'true' },
  { label: 'common_no', value: 'false' },
];

export const SEPARATE_TRANSACTION_SETTLEMENT_CALLBACK = [
  { label: 'devOption_radioButton_sameURL', value: 'true' },
  { label: 'devOption_radioButton_differentURL', value: 'false' },
];
